<template>
  <div class="blog-kits">
    <BlogKitsItem
      v-for="item in result"
      :key="(item.offer && item.offer.id) || item.id"
      :result="item"
    />
  </div>
</template>

<script>
import BlogKitsItem from './BlogKitsItem';

export default {
  name: 'BlogKits',
  components: {
    BlogKitsItem,
  },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.blog-kits {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 8px;
  overflow-y: auto;
  //padding-right: 10px;
  //flex-grow: 1;
  @include point-md {
    grid-gap: 12px;
  }
  @include point-lg {
    grid-gap: 12px;
  }
}
</style>
